module.exports = "/contribution/resources/259239173ec03bfbe374d5283906e4db.gif";